module.exports = __webpack_public_path__ + "static/media/foto_vehiculo_frente.47212359.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/user/foto_vehiculo_frente.jpg
// module id = 352
// module chunks = 0